import { memo, useCallback, useMemo, useState, useTransition } from "react";

import { CircleLoading } from "@/components/ui/loading/circle";

import { OptionStockTableForLaptop } from "./components";
import { YearAndMonthSelectBox } from "../../../../_shared";
import { FilterInSaleAndStopSellingForLaptop } from "../../../../_shared/components/filter/filter-insale-and-stop-selling/components";
import { useCreateInSaleAndStopSellingFilterProps } from "../hooks";

import type { OptionStockDiffStore } from "../../../model/usecase/use-create-form-model/option-stock-diff-store";
import type { ServerModel } from "../../../model/usecase/use-create-form-model/type";

type Props = {
	serverModel: ServerModel;
	optionStockDiffStore: OptionStockDiffStore;
	todaysDt: string;
	handleOnSelectYearOrMonth: (input: { startDt: string; endDt: string }) => Promise<void>;
};

export const OptionStockManagementForLaptop = memo(
	({ serverModel, optionStockDiffStore, todaysDt, handleOnSelectYearOrMonth }: Props) => {
		const { stopSellingItems, inSaleItems, itemsName } = useCreateInSaleAndStopSellingFilterProps({ serverModel });
		const initialSelectedItemIDs: string[] = useMemo(() => {
			if (inSaleItems.length >= 15) {
				return [inSaleItems.at(0)?.id || ""];
			}

			return inSaleItems.map((item) => item.id);
		}, [inSaleItems]);

		const [isPending, startTransition] = useTransition();
		const [selectedItemIDs, setSelectedItemIDs] = useState<string[]>(initialSelectedItemIDs);
		const onChangeSelectedItemIDs = useCallback((input: string[]) => {
			startTransition(() => {
				setSelectedItemIDs(input);
			});
		}, []);

		return (
			<>
				<div className="flex flex-col gap-y-6">
					<YearAndMonthSelectBox
						initialDt={todaysDt}
						onSelectYearOrMonthCallback={handleOnSelectYearOrMonth}
					/>
					<FilterInSaleAndStopSellingForLaptop
						isPending={isPending}
						itemsName={itemsName}
						selectedItemIDs={selectedItemIDs}
						onChangeSelectedItemIDs={onChangeSelectedItemIDs}
						inSaleItems={inSaleItems}
						stopSellingItems={stopSellingItems}
					/>
				</div>
				{isPending ? (
					<CircleLoading size="sm" />
				) : (
					<OptionStockTableForLaptop
						serverModel={serverModel}
						optionStockDiffStore={optionStockDiffStore}
						selectedItemIDs={selectedItemIDs}
					/>
				)}
			</>
		);
	},
);

OptionStockManagementForLaptop.displayName = "OptionStockManagementForLaptop";
